'use strict';

module.exports = function (val) {
  return val && typeof val.isValid == 'function' && val.isValid();
};


// WEBPACK FOOTER //
// ./src/components/vuetable-2-kernel/compiled/helpers/is-valid-moment-object.js